export default function SectionHeading({ eyebrow, title, description, align = "left", testid }) {
  const alignCls = align === "center" ? "text-center mx-auto" : "text-left";
  return (
    <div className={`max-w-3xl ${alignCls}`} data-testid={testid}>
      {eyebrow && (
        <p className="text-sm font-bold uppercase tracking-[0.3em] text-[#FEE123]" data-testid={testid ? `${testid}-eyebrow` : undefined}>
          {eyebrow}
        </p>
      )}
      <h2 className="font-display text-4xl sm:text-5xl md:text-6xl uppercase leading-none mt-3 text-white">
        {title}
      </h2>
      {description && <p className="mt-5 text-base sm:text-lg text-gray-300 leading-relaxed">{description}</p>}
    </div>
  );
}
